<template>
  <div class="futures_box">
    <!-- <div class="flex_between top_title">
      <div class="title _table_header">{{ $transform("US") }}</div>
      <div class="time _table_time">Last | {{ date }} UTC+8</div>
    </div> -->
    <div class="table_show" ref="table_show">
      <table-show :data="tableData" :height="tableHeight">
        <el-table-column prop="name" :label="$transform('SYMBOL')">
          <template slot-scope="{ row }">
            <span class="table_cell_1">{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="LAST" :label="$transform('YIELD')">
          <template slot-scope="{ row }">
            <span class="table_cell_2">{{ row.LAST }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="CHG" :label="$transform('CHANGE')">
          <template slot-scope="scope">
            <span
              class="flex_end reduce_icon"
              style="color: #ce2b2b; font-weight: 300"
              v-if="scope.row.CHG < 0 && scope.row.CHG"
              >{{ scope.row.CHG }}</span
            >
            <span
              class="flex_end add_icon"
              style="color: #008456; font-weight: 300"
              v-if="scope.row.CHG && scope.row.CHG > 0"
              >+{{ scope.row.CHG }}</span
            >
            <span
              v-if="!scope.row.CHG"
              style="width: 70px; color: #008456; font-weight: 300"
              class="flex_center"
              >-</span
            >
            <span
              v-if="
                scope.row.CHG &&
                !(scope.row.CHG && scope.row.CHG > 0) &&
                !(scope.row.CHG < 0 && scope.row.CHG)
              "
              class="flex_center"
              style="width: 70px;  font-weight: 300"
              >{{ scope.row.CHG }}</span
            >
          </template>
        </el-table-column>
      </table-show>
    </div>
    <bottom-tip></bottom-tip>
  </div>
</template>

<script>
import mixin from "@/libs/mixin";
export default {
  mixins: [mixin],
  data() {
    return {
      tableData: [],
      tableHeight: null,
      date: "",
    };
  },
  mounted() {
    this.loading = this.$loading();
    this.getBondsList(this.$route.query.type);
    this.changeView(this.$refs.table_show, () => {
      let h = this.$refs.table_show.offsetHeight;
      this.tableHeight = h;
    });
  },

  methods: {
    getBondsList(type) {
      return this.$tool
        .fetchPost("/api/getCharts5TabData", { type })
        .then((res) => {
          this.loading.close();
          if (res.code == 200 && res.data.length) {
            res.data.forEach((item) => {
              item.isreduce = parseFloat(item["%CHG"]) < 0;
            });
            this.tableData = res.data;
            this.date = res.data[0].DATA;
          }
        })
        .catch(() => {
          this.loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.futures_box {
  width: 100%;
  height: 100vh;
  .top_title {
    margin-bottom: 30px;

    .title {
      font-size: 32px;

      font-weight: 300;
      color: #333333;
    }
    .time {
      font-size: 12px;
      font-weight: 300;
      color: #333333;
    }
  }

  .table_show {
    margin-bottom: 10px;
    width: 100%;
    // height: calc(100vh - 75px - 17px - 10px);
    height: calc(100vh - 15px - 10px);

    .reduce_icon {
      width: 80px;
      &::after {
        content: "";
        width: 14px;
        height: 14px;
        background: url("../assets/images/down_reduce.png") no-repeat center
          center;
        background-size: 100% 100%;
        margin-left: 4px;
      }
    }
    .add_icon {
      width: 80px;
      &::after {
        content: "";
        width: 14px;
        height: 14px;
        background: url("../assets/images/up_add.png") no-repeat center center;
        background-size: 100% 100%;
        margin-left: 4px;
      }
    }
  }
}
</style>
